import MedicalPrescription from '../svg/Medical_prescription';

export function ClinicoDigitalManagement({ title, description }: { title: string, description: string }) {
    return (
        <section className="my-[20px] shadow-sm rounded-lg p-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-14 items-center">

                <div className="lg:col-span-2 col-span-1 flex flex-col justify-center lg:order-1 order-2">
                    <h3 className="sm:text-[28px] text-[20px] font-bold text-cardtitle leading-tight">
                        {title}
                    </h3>
                    <p className="mt-6 text-carddescription font-medium sm:text-base text-[15px] lg:text-[24px] leading-relaxed pl-6 ml-auto">
                        {description}
                    </p>
                </div>

                {/* Illustration */}
                <div className="flex justify-center lg:justify-start lg:order-2 order-1 motion-safe:animate-float">
                    <MedicalPrescription />
                </div>
            </div>
        </section>
    );
}
